<input
  #phoneInput
  type="tel"
  class="form-control phone-input__number"
  [id]="inputId"
  [disabled]="disabled"
  inputmode="tel"
  autocomplete="tel"
  (input)="updateValue()"
  (blur)="markAsTouched()">
